import { render, staticRenderFns } from "./CoursesBlock.vue?vue&type=template&id=125988c1"
import script from "./CoursesBlock.vue?vue&type=script&lang=js"
export * from "./CoursesBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports